import './DesignFourth.css';  

let DesignFourth=(props)=>{
    let tohideemptycell={
        PassPortNumber : props.sendpassportdata.paassportnumber,
        HeIght : props.sendphysicaldata.Height,
        WorkExp : props.ExperienceData[0].ExperianceYear,
        AcademicDataStream: props.AcademicData[0].ExamName,
        ComputerDataCourseName: props.ComputerData[0].CourseName,
        TechnicalDataCourseName: props.TechDataexp[0].TechCourseName, 


    } 
     

    let checkepmycells=()=>{

        let passportdatacont = document.querySelector('.passportdet');
        let physicaldatacont = document.querySelector('.physicaldet');
        let workdatacont = document.querySelector('.workexp_table');
        
        let academichildren = document.querySelector("#academicdata");
        let computerchildren = document.querySelector(".computertblcont");  
        let technicalchildren = document.querySelector(".techincaltblcont");

        if(tohideemptycell.PassPortNumber == "" || tohideemptycell.PassPortNumber == null){
            passportdatacont.style.display = "none";

        }  
        if(tohideemptycell.WorkExp == "" || tohideemptycell.WorkExp == null){
            workdatacont.style.display = "none";

        } 
        if(tohideemptycell.HeIght == "" || tohideemptycell.HeIght == null){ 
            physicaldatacont.style.display = "none";

        }
        if(tohideemptycell.AcademicDataStream == "" || tohideemptycell.AcademicDataStream == null){
            academichildren.style.display = "none";   

        }
            
        
        if(tohideemptycell.ComputerDataCourseName == "" || tohideemptycell.ComputerDataCourseName == null){
            computerchildren.style.display = "none";
        }
        if(tohideemptycell.TechnicalDataCourseName == "" || tohideemptycell.TechnicalDataCourseName == null){
            technicalchildren.style.display = "none";
        }     
    }

    setTimeout(() => {
        checkepmycells();
   }, 50);  

   let printfunction=()=>{
        window.print();
        
    }
    return(
        <div className='maincont_fouthdes'>
            <div className='descont'>
                <h3 className='heading_myres'>My Resume</h3>
            <div className='perdet_photo_cont'>
                <table className='perdet_table'>  
                    <thead> 
                        <tr>
                            <td colSpan="2">Personal Details</td>    
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>{props.UsersPersonlD.Name}{props.Userdata.applicantname
                            }</td>
                            </tr>
                            <tr>
                                <td>Father's Name</td>
                                <td> {props.UsersPersonlD.fname}{props.Userdata.fathername}</td>
                            </tr>
                            <tr>
                                <td>Mother's Name</td>
                                <td>{props.UsersPersonlD.Mname}{props.Userdata.mothername}</td>
                            </tr>     
                            <tr>
                                <td>Date Of Birth</td>
                                <td>{props.UsersPersonlD.dob}{props.Userdata.date}</td>
                            </tr>
                                <tr>
                            <td>Aadhaar Number</td>
                            <td>{props.sendpassportdata.AadhaarNum}</td>
                        </tr>
                    </tbody>
                </table>
                <div className='photo_contt'> 
                {
                    props.imagedataexp === "" ?  <img alt='photo' className='photp_profile' src={props.UsersPersonlD.Imagge}/> : <img alt='photo' className='photp_profile' src={props.imagedataexp}/>
                }
            
                </div>
            </div> 
            <table className='Address_table'>
                    <thead>
                        <tr>
                            <td colSpan="7">Address Details</td>    
                        </tr>
                    </thead>
                    <tbody>  
                        <tr>
                            <td>House No</td>
                            <td>Village</td>
                            <td>Thana</td>
                            <td>Post Office</td>
                            <td>District</td>
                            <td>State</td>
                            <td>Pin Code</td>
                        </tr>
                        <tr>
                            <td>{props.UsersPersonlD.hnum}{props.Userdata.Hnum}</td>
                            <td>{props.UsersPersonlD.Village}{props.Userdata.Vill}</td>
                            <td>{props.UsersPersonlD.Thana}{props.Userdata.police}</td>
                            <td>{props.UsersPersonlD.Post_Office}{props.Userdata.post}</td>
                            <td>{props.UsersPersonlD.District}{props.Userdata.city}</td>
                            <td>{props.UsersPersonlD.State}{props.Userdata.state}</td>
                            <td>{props.UsersPersonlD.Pin_Code}{props.Userdata.pincode}</td>
                        </tr>
                        
                       
                    </tbody>
                </table>
                <table className='Address_table'>
                    <thead>
                        <tr>
                            <td colSpan="7">Contact Details</td>    
                        </tr>
                    </thead>
                    <tbody>  
                        <tr>
                            <td>Mobile Number</td>
                            <td>Email Id</td>
                            <td>Alternate No</td>
                            
                        </tr>
                        <tr>
                            <td>{props.UsersPersonlD.mobnum}{props.Userdata.MobileNum}</td>
                            <td>{props.UsersPersonlD.Email_ID}{props.Userdata.Email}</td>
                            <td>{props.UsersPersonlD.Alternate}{props.Userdata.Altnum}</td>
                           
                        </tr>
                        
                       
                    </tbody>
                </table>
            

                <table className='Desfouthacademittable' id='academicdata'>
                            <caption className='Desfouthacademiccaption'>Academic Details</caption>
                            <thead>
                                <tr>
                                    <td>Stream</td>
                                    <td>Board/Univercity</td>
                                    <td>Passing Year</td>
                                    <td>%AGE</td>
                                </tr>
                            </thead>
                            <tbody>
                                {  
                                    props.AcademicData.map(
                                        AcAData =>(
                                            <tr>
                                            <td className='acad_td_loop'>{AcAData.ExamName}</td>
                                            <td className='acad_td_loop'>{AcAData.BoardName}</td>
                                            <td className='acad_td_loop'>{AcAData.PassingYear}</td>
                                            <td className='acad_td_loop'>{AcAData.PercentAge}</td>
                                            
                                        </tr>
                                        )
                                    )
                                }
                               
                            </tbody>
                        </table>
                        <table className='table_third computertblcont'>
                            <caption style={{border:"1px solid red", fontWeight:"bold"}}>Computer Qualification</caption>
                            <thead>
                                <tr>
                                    <td>Exam Name</td>
                                    <td>From</td> 
                                    <td>Passing Year</td>
                                    <td>%Age</td>
                                </tr>
                            </thead> 
                            <tbody>
                                { 
                                        props.ComputerData.map(
                                            CompData => (
                                                <tr>
                                                    <td className='acad_td_loop'>{CompData.CourseName}</td>
                                                    <td className='acad_td_loop'>{CompData.Frompass}</td>
                                                    <td className='acad_td_loop'>{CompData.Compassingy}</td>
                                                    <td className='acad_td_loop'>{CompData.compercent}</td>
                                                    
                                                </tr>
                                    
                                            )
                                        )
                                    }
                            </tbody>
                        </table>
                        <table className='table_fourth techincaltblcont'>
                            <caption style={{border:"1px solid red", fontWeight:"bold"}}>Technical Qualification</caption>
                            <thead>
                                <tr>
                                    <td>Exam Name</td>
                                    <td>Trade</td>
                                    <td>Passing Year</td>
                                    <td>%Age</td>
                                </tr>
                            </thead>
                                {
                                    props.TechDataexp.map(
                                        techdataaa =>(
                                            <tbody>
                                                    <tr>
                                                    <td className='tech_loop_td'>{techdataaa.TechCourseName}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechTradeName}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechPassingYear}</td>
                                                    <td className='tech_loop_td'>{techdataaa.TechPercentage}</td>
                                                </tr>
                                                <tr className='sub_tr2'>
                                                    <td colSpan='4'>  {techdataaa.Techfromwhere}</td>
                                                </tr>
                                        </tbody>
                                        )
                                    )
                                }
                        </table>
                <table className='passportdet'>
                    <thead>
                        <tr>
                            <td className='passhed' colSpan="2">Passport Details</td>    
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>{props.UsersPersonlD.Name}</td>
                        </tr>
                        <tr>
                            <td>Passport Number</td> 
                            <td>{props.sendpassportdata.paassportnumber}</td>
                        </tr>
                        <tr>
                            <td>Issuing Date</td>
                            <td>{props.sendpassportdata.passportissuingdate}</td>
                        </tr>
                        <tr>
                            <td>Expiry Date</td>
                            <td>{props.sendpassportdata.passportexpirydate}</td>
                        </tr>
                        <tr>
                            <td>District</td>
                            <td>{props.sendpassportdata.passportdistrict}</td>
                        </tr>
                    </tbody>
                </table>


                <table className='physicaldet'>
                    <thead>
                        <tr>
                            <td colSpan="4">Physical Details</td>    
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Height</td>  
                            <td>Weight</td>
                            <td>Blood Group</td>
                            <td>PwP Disability</td>
                        </tr>
                        <tr>
                            <td>{props.sendphysicaldata.Height}</td>
                            <td>{props.sendphysicaldata.weight}</td>
                            <td>{props.sendphysicaldata.BloodGroup}</td>
                            <td>{props.sendphysicaldata.Pwpdisability}</td>
                        </tr>
                       
                       
                    </tbody>
                </table>
                <table className='workexp_table'>
                    <caption>Work Experiance</caption>
                    <thead>
                        <tr>
                        <td>Worked Years</td>
                            <td>Worked As</td>
                            <td>Company Name/Address</td>
                            <td>Period</td>
                        </tr>
                    </thead>
                    <tbody>
                        {  
                            props.ExperienceData.map(
                                ExpdataToExpComp =>( 
                                    <tr colSpan={5} className='loop_li_of_exp'>
                                        <td className='workspan'>{ExpdataToExpComp.ExperianceYear} </td>
                                        
                                        <td className='workspan'> {ExpdataToExpComp.CompanyName} </td> 
                                        
                                        <td className='workspan'> {ExpdataToExpComp.CompanyAddress} </td> 
                                       
                                        <td className='workspan'> {ExpdataToExpComp.FromDateToDate } </td>
                                    </tr>
                                )
                            )
                        }
                        
                        
        
                       
                    </tbody>
                </table>
            </div>
            
 
                

                <div className='printbtn' style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <button style={{padding: "10px 20px", backgroundColor: "lightblue", border: "none", color: "black", borderRadius: "5px",  fontSize: "22px"}} onClick={printfunction}>Print</button>
                </div>
                
        </div>
    );

}
export default DesignFourth;